/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Row, Col, Modal, Table } from 'react-bootstrap';
import {
  HeadingDescSmall,
  HeadingWithSpaceLarge,
  HeadingDescVsmall
} from '../../Headings';
import { AncerWithUnderlineSmall } from '../../button';
import downloadIcon from '../../../assets/images/svg/download-with-border.svg';
import checkIcon from '../../../assets/images/svg/check-green.svg';
import SimpleTag from '../../tags/simpleTag/SimpleTag';
import './viewPrecriptionModal.css';

const prescriptions = [
  {
    drugName: 'Tylenol Syrup(100mg)',
    withMeal: true,
    medicinePerDay: {
      morning: '2 Teaspoon',
      afternoon: '',
      evening: '2 Teaspoon'
    },
    totalDays: '5'
  },
  {
    drugName: 'Tylenol Syrup(100mg)',
    withMeal: true,
    medicinePerDay: {
      morning: '2 Teaspoon',
      afternoon: '1 Tablet',
      evening: '2 Teaspoon'
    },
    totalDays: '5'
  },
  {
    drugName: 'Tylenol Syrup(100mg)',
    withMeal: true,
    medicinePerDay: {
      morning: '2 Teaspoon',
      afternoon: '1 Tablet',
      evening: '2 Teaspoon'
    },
    totalDays: '5'
  },
  {
    drugName: 'Tylenol Syrup(100mg)',
    withMeal: true,
    medicinePerDay: {
      morning: '1 Drop',
      afternoon: '',
      evening: '1 Drop'
    },
    totalDays: '5'
  }
];

function ViewPrecriptionModal(props) {
  const { show, close } = props;

  function colorType(type) {
    // eslint-disable-next-line no-param-reassign
    type = type.toString().toLowerCase();
    if (type.includes('drop')) {
      return 'tifannyblue';
    }
    if (type.includes('tablet')) {
      return 'red';
    }
    if (type.includes('teaspoon')) {
      return 'green';
    }
    if (type.includes('tablespoon')) {
      return 'green';
    }

    return '';
  }

  return (
    <Modal
      show={show}
      className="modalLayout viewPrescriptionModal"
      onHide={close}
      centered
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton onHide={close}>
        <div>
          <HeadingWithSpaceLarge text="YOUR REVIEW" />
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="content">
          <div className="downloadContainer">
            <div>
              <HeadingDescSmall text="Start Date: 01 March. 2022 | End Date: 06 March 2022 | DHA Clinic Karachi" />
            </div>
            <div>
              <button type="button">
                <img src={downloadIcon} alt="downloadIcon" />
              </button>
              <AncerWithUnderlineSmall text="download" />
            </div>
          </div>
          <Row>
            <Col md={12}>
              <div className="viewPrescription">
                <Table responsive>
                  <thead>
                    <tr className="tableFirstHead">
                      <th>
                        <HeadingDescVsmall text="Drug Name" />
                      </th>
                      <th>
                        <HeadingDescVsmall text="With Meal" />
                      </th>
                      <th> </th>
                      <th>
                        <HeadingDescVsmall text="Medicine/Day" />
                      </th>
                      <th> </th>
                      <th>
                        <HeadingDescVsmall text="Total Days" />
                      </th>
                    </tr>
                  </thead>
                  <thead>
                    <tr>
                      <th> </th>
                      <th> </th>
                      <th>
                        <HeadingDescVsmall text="Morning" />
                      </th>
                      <th>
                        <HeadingDescVsmall text="Afternoon" />
                      </th>
                      <th>
                        <HeadingDescVsmall text="Evening" />
                      </th>
                      <th> </th>
                    </tr>
                  </thead>
                  <tbody>
                    {prescriptions.map((prescription, index) => {
                      // eslint-disable-next-line operator-linebreak
                      const { drugName, withMeal, medicinePerDay, totalDays } =
                        prescription;
                      return (
                        <tr key={index}>
                          <td>
                            <HeadingDescVsmall text={drugName} />
                          </td>
                          <td>
                            <HeadingDescVsmall text={withMeal} />
                            <div className="custom__radio check">
                              <input type="radio" name="custom" id={index} />
                              <label htmlFor="html">
                                <img src={checkIcon} alt="checkIcon" />
                              </label>
                            </div>
                          </td>
                          <td className={colorType(medicinePerDay.morning)}>
                            <SimpleTag text={medicinePerDay.morning} />
                          </td>
                          <td className={colorType(medicinePerDay.afternoon)}>
                            <SimpleTag text={medicinePerDay.afternoon} />
                          </td>
                          <td className={colorType(medicinePerDay.evening)}>
                            <SimpleTag text={medicinePerDay.evening} />
                          </td>
                          <td>
                            <HeadingDescVsmall text={totalDays} />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </Col>
          </Row>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ViewPrecriptionModal;
